import script from "./leavingRequestReport.vue?vue&type=script&setup=true&lang=js"
export * from "./leavingRequestReport.vue?vue&type=script&setup=true&lang=js"

import "./leavingRequestReport.vue?vue&type=style&index=0&id=97905856&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97905856"]])

export default __exports__